
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 13.999v-2h9v2H0zm0-8v-2h9v2H0zm14.375 10l-3.55-3.55 1.4-1.4 2.125 2.125 4.25-4.25 1.4 1.425-5.625 5.65zm0-8l-3.55-3.55 1.4-1.4 2.125 2.125L18.6.924 20 2.349l-5.625 5.65z","fill":"#fff"}})])
          )
        }
      }
    